import moment from 'moment'
import Vform from 'vform'

import store from '~/store'
import {
  isArray,
  endsWith,
  includes,
  isString,
  isObject,
  noReactive,
  getFileName,
  checkVariable,
  getObjectValue,
  getAmountOfKeys,
  getNumberFormat,
  getFirstOccurrence,
} from './helper'

/**
 * @return {Array}
 */
export const getUserModules = () => {
  const modules = []
  if (
    (!checkVariable(store.getters.authorize)) ||
    (!checkVariable(store.getters.authorize.modules))
  ) {
    return modules
  }
  for (const key in store.getters.authorize.modules) {
    if (store.getters.authorize.modules.hasOwnProperty(key) && store.getters.authorize.modules[key].has) {
      const temp = {}
      const name = store.getters.authorize.modules[key].id_name
      temp[key] = {
        id_name: name,
        default_route: 'index',
        has: store.getters.authorize.modules[key].has,
      }
      if (endsWith(name, 'index', name.length)) {
        const action = getFileName(name, '.')
        temp[key] = {
          ...temp[key],
          has: determinesInspectionAction(action),
          default_route: action,
        }
      }

      modules.push(temp)
    }
  }

  return modules
}

/**
 * @return {Array}
 */
export const getUserRoles = () => {
  const roles = []
  if (
    (!checkVariable(store.getters.authorize)) ||
    (!checkVariable(store.getters.authorize.roles))
  ) {
    return roles
  }
  for (const key in store.getters.authorize.roles) {
    if (store.getters.authorize.roles.hasOwnProperty(key) && store.getters.authorize.roles[key]) {
      roles.push(key)
    }
  }

  return roles
}

/**
 *  @return {Array}
 */
export const getPermissions = () => {
  const permits = []
  if (
    (!checkVariable(store.getters.authorize)) ||
    (!checkVariable(store.getters.authorize.permissions))
  ) {
    return permits
  }
  for (const key in store.getters.authorize.permissions) {
    if (store.getters.authorize.permissions.hasOwnProperty(key) && store.getters.authorize.permissions[key]) {
      permits.push(key)
    }
  }

  return permits
}

/**
 * Determina si un usuario cuenta con el
 * permiso para ver una acción
 * @param {Array} currentRoles
 * @return {Boolean}
 */
export const determineInspection = currentRoles => {
  if (!checkVariable(currentRoles)) {
    return false
  }
  if (!isArray(currentRoles) && !isString(currentRoles)) {
    return false
  }

  let i = 0
  let sw = false
  const roles = getUserRoles()
  if (!isArray(roles)) {
    return sw
  }
  while (i < roles.length && sw === false) {
    sw = currentRoles.includes(roles[i])
    i++
  }

  return sw
}

/**
 * @param {Array|String} currentPermits
 * @return {Boolean}
 */
export const determinesInspectionAction = currentPermits => {
  if (!checkVariable(currentPermits)) {
    return false
  }
  if (!isArray(currentPermits) && !isString(currentPermits)) {
    return false
  }

  let i = 0
  let sw = false
  const permits = getPermissions()
  if (!isArray(permits)) {
    return sw
  }
  while (i < permits.length && sw === false) {
    sw = currentPermits.includes(permits[i])
    i++
  }

  return sw
}

/**
 * @param {Array|String} currentModules
 * @return {Boolean}
 */
export const determinesModuleInspection = currentModules => {
  if (!checkVariable(currentModules)) {
    return false
  }
  if (!isArray(currentModules) && !isString(currentModules)) {
    return false
  }

  let i = 0
  let sw = false
  const modules = getUserModules()
  if (!isArray(modules)) {
    return sw
  }
  while (i < modules.length && sw === false) {
    sw = includes(currentModules, modules[i], 'has')
    i++
  }

  return sw
}

/**
 * @param {Array} currentPermits
 * @param {String} action
 * @return {String|Boolean}
 */
export const determineModule = currentModules => {
  if (!checkVariable(currentModules)) {
    return false
  }
  if (!isArray(currentModules) && !isString(currentModules)) {
    return false
  }

  let sw = false
  let route = null
  const modules = getUserModules()
  for (const currentKey in modules) {
    const check = getObjectValue(modules, currentKey)
    if (checkVariable(check)) {
      const newModules = modules[currentKey]
      for (const controller in newModules) {
        if (checkVariable(getObjectValue(newModules, controller))) {
          const result = getFirstOccurrence(currentModules, controller)
          if (checkVariable(result)) {
            route = `${newModules[result].id_name}`
            sw = true
          }
        }
      }
      if (sw) {
        break
      }
    }
  }

  return route
}

/**
 * Compare two variables
 * @param {String} status
 * @param {String} wanted
 * @return {Bool}
 */
export const determineState = (status, wanted) => {
  if (status === wanted) {
    return true
  }

  return false
}

/**
 * @param {String} status
 * @param {String} wanted
 *
 * @return {Bool}
 */
export const verifyStatus = (status, wanted) => {
  switch (status) {
    case 'finiquito':
      return determineState(status, wanted) ?? false
    default:
      return determineState(status, wanted)
  }
}

/**
 * Determines if a user can perform actions
 * in a certain module
 * @param {Array} permits
 * @param {Object} contractStates
 * @param {String|Array} status
 * @return {Bool}
 */
export const determinePermissionInOption = (permits, contractStates, status) => {
  const allowedPermission = determinesInspectionAction(permits)
  if (allowedPermission && contractStates) {
    if (typeof status === 'string') {
      return verifyStatus(status, contractStates.nombre_id)
    } else {
      if (status && Array.isArray(status)) {
        let i = 0
        let sw = false
        while (i < status.length && !sw) {
          sw = verifyStatus(status[i], contractStates.nombre_id)
          i++
        }

        return sw
      }
    }
  }

  return false
}

/**
 * Devuelve un nuevo objeto con elementos
 * válidos o no indefinidos
 * @param {Object} params
 * @return {Object}
 */
export const getFilterInformation = (params) => {
  const newObject = {}
  Object.keys(params).map((key, index) => {
    if (checkVariable(params[key])) {
      newObject[key] = params[key].toString()
    }
  })

  return newObject
}

/**
 * Crea un arreglo formateado específicamente
 * para utilizarlo en el generador de tabla
 * @param {String} template
 * @param {Array} defaultName
 * @param {String} prefix
 * @param {Array} values
 * @param {Object} editableOptions
 * @param {Object} defaultValues
 * @param {Array} keysForList
 * @param {Array} typeDate
 * @param {Number} idDefault
 * @return {Array}
 */
export const newAssignment = function (
  {
    template,
    defaultName,
    prefix,
    values,
    editableOptions,
    defaultValues,
    keysForList,
    inputValueType,
    typeDate,
    idDefault,
  },
) {
  const length = (values && values.length > 0) ? values.length : 1
  const visibleRows = []
  let dateArray = []
  let date = null
  let i = 0

  if (typeof typeDate === 'undefined') {
    typeDate = []
  }

  while (i < length) {
    let k = 0
    visibleRows[i] = []

    while (k < defaultName.length) {
      const value = values && values[i] ? values[i] : ''
      let editable = value && value.editable !== undefined ? value.editable : true
      if (editable && editableOptions !== undefined && Object.keys(editableOptions).length > 0) {
        editable = editableOptions.keysDisabled.indexOf(defaultName[k]) !== -1
          ? editableOptions.editable
          : editableOptions.inspeccion
      }
      let params = {}
      const text = value !== '' && value[defaultName[k]] !== undefined && value[defaultName[k]] !== null ? value[defaultName[k]] : ''
      if (keysForList.indexOf(defaultName[k]) === -1 && typeDate.indexOf(defaultName[k]) === -1) {
        params = {
          tag: 'input',
          value: defaultValues[defaultName[k]] || text,
          min: 2,
          max: 191,
        }
      } else if (keysForList.indexOf(defaultName[k]) !== -1 && ['files', 'file'].indexOf(defaultName[k]) !== -1) {
        params = {
          tag: 'input',
          type: 'file',
          value: text,
          accept: 'application/pdf,image/x-png,image/jpeg, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
        }
      } else if (keysForList.indexOf(defaultName[k]) === -1 && typeDate.indexOf(defaultName[k]) !== -1) {
        date = defaultValues[defaultName[k]] || text
        if (date && date !== undefined && date !== null) {
          dateArray = date.split('-')
          date = `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`
        }
        params = {
          tag: 'input',
          type: 'date',
          value: (date && date !== undefined && date !== null) ? moment(date).format('YYYY-MM-DD') : '',
        }
      } else {
        if (defaultValues && defaultValues[defaultName[k]] && Array.isArray(defaultValues[defaultName[k]])) {
          params = {
            tag: 'select',
            value: text,
            option: defaultValues[defaultName[k]],
          }
        } else {
          if (defaultValues && defaultValues[defaultName[k]]) {
            const currentValue = defaultValues[defaultName[k]]
            params = {
              value: text,
              tag: currentValue.tag,
              option: currentValue.value,
              url: currentValue.url || null,
              runserver: currentValue.runServer || false,
              useReferenceEvent: currentValue.useReferenceEvent || false,
            }
          }
        }
      }

      let id = value && value.id !== undefined ? value.id : (i + 1)
      if (!checkVariable(value) && checkVariable(idDefault)) {
        id = idDefault
      }
      if (
        editable &&
        editableOptions !== undefined &&
        editableOptions['disabled'] !== undefined &&
        editableOptions['keysDisabled'] !== undefined
      ) {
        if (editableOptions.keysDisabled.indexOf(defaultName[k]) !== -1) {
          params = {
            ...params,
            disabled: editableOptions['disabled'],
          }
        }
      }

      if (checkVariable(inputValueType) && getAmountOfKeys(inputValueType) > 0 && checkVariable(inputValueType[defaultName[k]])) {
        params = { ...params, ...inputValueType[defaultName[k]] }
      }

      visibleRows[i].push({
        id,
        visible: true,
        editable,
        lugar: template,
        name: `${prefix}${defaultName[k]}`,
        parent_id: value['parent_id'] || null,
        ...params,
        styles: value && value.styles !== undefined ? value.styles : undefined,
      })
      k++
    }
    i++
  }

  return visibleRows
}

/**
 * Obtiene un arreglo formateado específicamente
 * para utilizarlo en el generador de tabla
 * @param {String} template
 * @param {Array} defaultName
 * @param {String} prefix
 * @param {Array} values
 * @param {Object} editableOptions
 * @param {Object} defaultValues
 * @param {Array} keysForList
 * @param {Array} typeDate
 * @return {Array}
 */
export const getNewAssignment = ({ template, defaultName, prefix, defaultValues, values, editableOptions, keysForList, typeDate }) => {
  return newAssignment({
    template,
    defaultName,
    prefix,
    values,
    defaultValues,
    keysForList,
    editableOptions,
    typeDate,
  })
}

/**
 * @param {Array} columnsDefault
 * @return {Array}
 */
export const creationOfColumns = (columnsDefault) => {
  const columns = []
  columnsDefault.forEach(temp => {
    let rules = { id: 0, hide: true, visible: true }
    if (isObject(temp)) {
      rules = { ...rules, ...temp }
    } else {
      rules = { ...rules, title: temp }
    }
    columns.push(rules)
  })

  return columns
}

export const getLongerTextElement = function (array, defaultValue, key) {
  let may = defaultValue
  const defaultKey = 0
  if (checkVariable(may)) {
    array.forEach(element => {
      if (Array.isArray(element[key])) {
        const currentValue = checkVariable(element[key][defaultKey]) ? element[key][defaultKey] : ''
        const currentValueLength = currentValue.length
        if (may < currentValueLength) {
          may = currentValueLength
        }
      }
    })
  }

  return may
}

/**
 * Obtener el último elemento del arreglo
 * @param {Array} rows
 * @return {Array}
 */
export const getTheLastRow = rows => {
  let i = rows.length - 1
  const tempRow = []
  while (i >= 0) {
    const currentRow = rows[i]
    if (Array.isArray(currentRow)) {
      currentRow.forEach((row, k) => {
        if (Array.isArray(row)) {
          row.forEach(r => {
            if (r.visible) {
              tempRow.push(currentRow)
              i = 0
            }
          })
        } else {
          if (row.visible) {
            tempRow.push(row)
            i = 0
          }
        }
      })
    } else {
      if (currentRow.visible) {
        tempRow.push(currentRow)
        i = 0
      }
    }
    i--
  }

  return tempRow
}

/**
 * @param {Object} row
 * @return {Object}
 */
const _defaultValuesWhenCopying = row => {
  const copy = Object.assign({}, row)
  copy.id = 0
  copy.editable = true
  copy.value = !isArray(copy.value) ? '' : isArray(copy.value) ? new Array(copy.value.length) : null
  if (copy.disabled !== undefined) {
    copy.disabled = false
  }
  if (copy.aprobado !== undefined) {
    copy.aprobado = false
  }
  if (copy.id_reference !== undefined) {
    copy.id_reference = null
  }

  return copy
}

/**
 * Asigna nuevo valores al arreglo creado por el método getTheLastRow
 * @param {Array} rows
 * @return {Array}
 */
export const setNewAssignment = rows => {
  const tempdata = []
  if (Array.isArray(rows)) {
    rows.forEach((currentRow, index) => {
      if (Array.isArray(currentRow)) {
        tempdata[index] = []
        currentRow.forEach(row => {
          if (Array.isArray(row)) {
            row.forEach(r => {
              tempdata[index].push(_defaultValuesWhenCopying(r))
            })
          } else {
            tempdata[index].push(_defaultValuesWhenCopying(row))
          }
        })
      } else {
        tempdata.push(_defaultValuesWhenCopying(currentRow))
      }
    })
  }

  return tempdata
}

export const arming = (source, key) => {
  let timer = null
  return new Promise(function (resolve, reject) {
    clearTimeout(timer)
    timer = setTimeout(
      function () {
        const original = noReactive(source)
        const origigen = []
        let temp = []
        let index = 0

        for (let i = 0; i < original.length; i++) {
          if (typeof original[i] !== typeof undefined && typeof original[i][key] !== typeof undefined) {
            temp = []
            temp['id'] = original[i]['id']
            temp[key] = original[i][key]

            origigen[index] = Object.assign({}, temp)
            index++
          }
        }

        const target = noReactive(origigen)
        clearTimeout(timer)
        resolve({ target })
      },
      100,
    )
  })
}

/**
 * @param {Object} target
 * @param {Object} sources
 * @return {Promise}
 */
export const mergeDeep = ({ target }, sources) => {
  let timer = null
  return new Promise(
    function (resolve, reject) {
      clearTimeout(timer)
      timer = setTimeout(
        function () {
          const original = noReactive(target)
          const tempSources = noReactive(sources.target)

          for (let i = 0; i < tempSources.length; i++) {
            const source = tempSources[i]

            for (const key in source) {
              if (source.hasOwnProperty(key)) {
                try {
                  original[i][key] = source[key]
                } catch (ex) {
                  console.warn(ex)
                }
              }
            }
          }

          clearTimeout(timer)

          resolve({ target: original })
        },
        100,
      )
    },
  )
}

/**
 * Creación de un nuevo objeto con
 * los valores utilizados solamente
 * @param {Object} object
 * @return {Object}
 */
export const applySketchOfObjects = async (object) => {
  const temp = {}

  if (object.name !== undefined) {
    temp['id'] = object.id
    temp['lugar'] = object.lugar
    temp['visible'] = object.visible
    temp[object.name] = object.value
    temp['parent_id'] = object.parent_id || null
    temp['policy_id'] = object.policy_id || null
  }

  return temp
}

/**
 * Configuración inicial para la unificación
 * de objetos que representan una fila
 * @param {Array} rows
 * @return {Array}
 */
export const unifyObjectsOfRows = (rows) => {
  const tempData = []
  const tempRemove = []
  let indexData = 0
  let indexRemove = 0
  const newRows = noReactive(rows)

  newRows.forEach((values, index) => {
    values.forEach(async (object, key) => {
      const temp = await applySketchOfObjects(object)
      if (temp && temp.visible) {
        tempData[indexData] = temp
        indexData++
      } else if (temp && !temp.visible) {
        tempRemove[indexRemove] = temp
        indexRemove++
      }
    })
  })

  return {
    activa: tempData,
    desactivada: tempRemove,
  }
}

/**
 * Obtiene el color en base al porcentaje
 * avanzado en la cuenta
 * @param {Number} percentage
 * @return {String}
 */
export const getColor = percentage => {
  let backgroundColor = ''
  percentage = parseInt(percentage)
  if (percentage === 0) {
    backgroundColor = '#dcabab'
  } else if (percentage >= 1 && percentage <= 49) {
    backgroundColor = '#e89e5c'
  } else if (percentage >= 50 && percentage <= 99) {
    backgroundColor = '#efe253'
  } else {
    backgroundColor = '#94f774'
  }

  return backgroundColor
}

/**
 * @param {Object} form
 * @return {Object}
 */
export const createForm = form => {
  const newForm = new Vform(form.originalData)
  if (Object.keys(form).length > 0) {
    Object.keys(form).forEach(key => {
      newForm[key] = form[key]
    })
  }

  return newForm
}

/**
 * @param {Number} timer
 */
export const waitInAWhile = timer => {
  return new Promise(resolve => setTimeout(resolve, timer))
}

/**
 * @param {Array} datos
 * @param {String} key
 * @return {Number}
 */
export const calculateTotalInvoicesAndChecks = (datos, key) => {
  if (checkVariable(datos) && datos.length > 0) {
    let total = 0
    datos.forEach(dato => {
      let value = 0
      const newValue = getObjectValue(dato, key)
      if (checkVariable(newValue)) {
        value = parseFloat(newValue)
      }
      total = total + value
    })

    return total
  }

  return 0
}

/**
 * @param {Array} datos
 * @return {Number}
 */
export const calculateTotalSmallCashService = datos => {
  if (checkVariable(datos) && datos.length > 0) {
    let total = 0
    datos.forEach(dato => {
      const tax = parseFloat(dato.precio) * parseFloat(dato.impuesto) / 100
      const withTax = dato.precio + tax
      total = total + withTax
    })

    return getNumberFormat(total)
  }

  return 0
}

/**
 * @param {String} action
 * @param {Array} data
 * @param {String} message
 */
export const captureDataToRevert = (action, data, message, alternativeUrl) => {
  if (checkVariable(data)) {
    const object = {
      request: { action, data },
      message,
      alternativeUrl,
    }

    store.dispatch('captureRecordData', object)
  }
}
